<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="77" height="76" viewBox="0 0 77 76" fill="none">
            <path d="M24.9434 51.313L17.9292 55.3601C21.9764 60.1566 27.5725 63.3881 33.7499 64.4959V56.3987C30.4065 55.5343 27.3619 53.775 24.9434 51.3099V51.313ZM56.8127 32.9147L63.8205 28.8677C65.9494 34.7701 65.9494 41.2307 63.8205 47.133L56.8127 43.0892C57.7309 39.7586 57.7297 36.2416 56.8095 32.9115L56.8127 32.9147ZM59.0705 20.6407L52.0532 24.6877C49.6352 22.2243 46.5918 20.4661 43.2499 19.602V11.5049C49.4272 12.6127 55.0233 15.8442 59.0705 20.6407ZM43.2499 64.4959C49.4272 63.3881 55.0233 60.1566 59.0705 55.3601L52.0564 51.313C49.6375 53.777 46.5929 55.5352 43.2499 56.3987V64.4959Z" stroke="#7AC4EB" stroke-width="2" stroke-linejoin="round" />
            <path d="M16.6658 45.0941C15.1681 40.4838 15.1681 35.5177 16.6658 30.9074M21.4379 22.6392C24.6819 19.0369 28.9829 16.5539 33.7246 15.5459" stroke="#7AC4EB" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>

        <h2 class="modal-header-title">{{ $t('modals.vasion_confirmation.title') }}</h2>
      </div>
      <div class="modal-body">
        <p class="modal-body-text">{{ $t('modals.vasion_confirmation.message') }}</p>
      </div>
      <div class="modal-footer">
        <button class="cancel-button" @click="$emit('close')" :disabled="loading">{{ $t('modals.vasion_confirmation.cancel') }}</button>
        <button class="confirm-button" @click="$emit('confirm')" :disabled="loading">
        
          <span>{{ $t('modals.vasion_confirmation.confirm') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'VasionConfirmationModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useI18n()
    return { t }
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 10px;
  width: 400px;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10000;
}

.modal-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.modal-header h2 {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.24px;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 24px;
}

.modal-body p {
  color: #32393e;
  font-family: Archivo;
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.cancel-button,
.confirm-button {
  width: 123.915px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 2px solid var(--primary-color);
  color: #fff;
  text-align: center;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.cancel-button {
  background: white;
  border: 1px solid #e8e8e8;
  color: #5c656c;
  color: var(--primary-color);
  text-align: center;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.confirm-button {
  background: var(--primary-color);
  border: none;
  color: white;
}

.cancel-button:hover {
  background-color: #f5f5f5;
}

.confirm-button:hover:not(:disabled) {
  background-color: #123a50;
}

.confirm-button:disabled,
.cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.confirm-button:disabled:hover {
  background-color: var(--primary-color);
}
.modal-header-icon {
  display: flex;
  width: 100px;
  height: 100px;
  padding: var(--Micro-XL, 12px);
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background: #f0f9fd;
}
.modal-header-title {
  color: var(--primary-color);
  text-align: center;
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 166.667% */
  margin-top: 20px;
}
.modal-body-text {
  text-align: center;
}

.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.125em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.text-white {
  color: #fff !important;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.confirm-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
</style>
